// extracted by mini-css-extract-plugin
export default {"list":"BubbleList_list__UW8sL","item":"BubbleList_item__I31X5","deleteIcon":"BubbleList_deleteIcon__34QBl"};